import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

/**
 * Label configuration for the ASTM D2974 organic content, excluding the moisture content test performed for oven drying.
 * TODO: This is a partial config
 */
const getLabelConfig = (prefix: string) =>
  convertLabelMapToConfig({
    [`${prefix}.AirDrying.DryMassReadings.DateTimeMeasuredLocal`]: 'Time Measured',
    [`${prefix}.AirDrying.DryMassReadings.TareAndDryMass`]: 'Container and Material Air-Dried Mass',
  });

/**
 * Label configuration for the ASTM D2974 moisture content determination performed for oven drying.
 * Only applies when this moisture content is presented in a standalone context (e.g. in the Dry Mass Entry grid)
 */
const getMoistureContentLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Equipment.Balance`]: `Balance`,
      [`${prefix}.Equipment.DryMassBalance`]: `Dry Mass Balance`,
      [`${prefix}.Equipment.Oven`]: `Oven`,
      [`${prefix}.Equipment.DryingTemperature`]: `Drying Temperature`,

      [`${prefix}.DryingTray.ContainerLabel`]: `Tare ID`,
      [`${prefix}.DryingTray.ContainerMass`]: `Tare Mass`,
      [`${prefix}.DryingTray.WetSoilAndContainerMass`]: `Tare and Material Wet Mass`,
      [`${prefix}.DryingTray.WetSoilMass`]: `Material Wet Mass`,
      [`${prefix}.DryingTray.ConstantDrySoilAndContainerMass`]: `Tare and Material Dry Mass`,
      [`${prefix}.DryingTray.ConstantDrySoilMass`]: `Material Dry Mass`,

      [`${prefix}.DryingTray.DateTimePlacedInOvenLocal`]: `Date and Time in Oven`,

      [`${prefix}.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: `Tare and Material Dry Mass`,
      [`${prefix}.DryingTray.DryMassReadings.DrySoilMass`]: `Material Dry Mass`,
      [`${prefix}.DryingTray.DryMassReadings.DateTimeRemovedFromOvenLocal`]: `Date and Time Out of Oven`,
      [`${prefix}.DryingTray.DryMassReadings.DryingTime`]: `Drying Time`,

      [`${prefix}.Results.MoistureContentPercent`]: `Water Content`,
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Results.MoistureContentPercent`]: '%',
    })
  );

export { getLabelConfig, getMoistureContentLabelConfig };
